import React from 'react';

import { Button, Grid, Section } from '@gogame/components';
import { withFormField } from '@gogame/form';

import { ENGAGEMENT_EVENTS } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';
import { useCanEditAll } from 'scenes/CustomAudiences/EditGranularityContext';

import Engagement from './Engagement';

const FieldSet = ({ value = [], onChange }) => {
  const canEditAll = useCanEditAll();
  const handleAdd = (e) => {
    const newValue = [...value, { value: true }];
    onChange(e, newValue);
  };

  const handleRemove = (e, findIndex) => {
    const newValue = value.filter((_el, index) => index !== findIndex);
    onChange(e, newValue);
  };

  return (
    <Section title={'Engagement Events'}>
      <Grid container spacing={3}>
        {value.map((_, index) => (
          <Grid item xs={6}>
            <Engagement
              key={index}
              index={index}
              onRemove={(e) => handleRemove(e, index)}
              disabled={!canEditAll}
            />
          </Grid>
        ))}
        <Grid item xs={12}>
          <Button
            add
            onClick={handleAdd}
            disabled={!canEditAll}
            variant={'outlined'}
          >
            Event
          </Button>
        </Grid>
      </Grid>
    </Section>
  );
};

export default withFormField({ name: ENGAGEMENT_EVENTS, padding: 0 })(FieldSet);
